import React from 'react';
import { HwtButton } from 'components/@common/Buttons/HwtButton';
import { translate } from 'translations/translator';
type Props = {
  handleAssignLesson: () => void;
  className: string;
  disabled: boolean;
};
const getTranslation = key => translate('lessonPlanner', key);

export const DayCardActionGroup = ({ handleAssignLesson, disabled, ...props }: Props) => {
  return (
    <div {...props}>
      <HwtButton
        disabled={disabled}
        size="small"
        variant="outlined"
        style={{
          width: '130px'
        }}
        onClick={handleAssignLesson}
      >
        {getTranslation('assignLesson')}
      </HwtButton>
    </div>
  );
};
